import type { DirectiveBinding, ObjectDirective, VNode } from 'vue';
import type { Router } from 'vue-router';

type Handler = (event: MouseEvent) => void;

const handlerMap = new WeakMap<Element, Handler>();

export const vCatchAppLinks: ObjectDirective<Element> = {
    mounted(el: Element, binding: DirectiveBinding, vnode: VNode) {
        const regex: RegExp | undefined = binding.value ?? window.kgrDynamicConfig?.appUrlRegex;
        if (!regex) {
            return;
        }

        const router: Router | undefined = vnode.appContext?.app?.config?.globalProperties?.$router;
        if (!router) {
            return;
        }

        const handler: Handler = (event: MouseEvent) => {
            if (event.altKey || event.ctrlKey || event.shiftKey || event.metaKey) {
                return;
            }

            const target = event.target as HTMLElement;
            const anchor = target instanceof HTMLAnchorElement ? target : target.closest('a');
            if (!anchor || !el.contains(anchor)) {
                return;
            }

            const href = anchor.href;
            if (!href || !regex.test(href)) {
                return;
            }

            event.preventDefault();
            router.push(href.replace(regex, '$1') || '/');
        };

        el.addEventListener('click', handler as EventListener);
        handlerMap.set(el, handler);
    },

    unmounted(el: Element) {
        const handler = handlerMap.get(el);
        if (handler) {
            el.removeEventListener('click', handler as EventListener);
            handlerMap.delete(el);
        }
    },
};
